"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable no-unused-vars */

const Column = _ref => {
  let {
    className,
    renderAs,
    children,
    width,
    isThreeQuarters,
    isTwoThirds,
    isHalf,
    isOneThird,
    isOneQuarter,
    isFull,
    isFourFifths,
    isThreeFifths,
    isTwoFifths,
    isOneFifth,
    size,
    offsetSize,
    isOffsetThreeQuarters,
    isOffsetTwoThirds,
    isOffsetHalf,
    isOffsetOneThird,
    isOffsetOneQuarter,
    isOffsetFourFifths,
    isOffsetThreeFifths,
    isOffsetTwoFifths,
    isOffsetOneFifth,
    isNarrow,
    isNarrowMobile,
    isNarrowTablet,
    isNarrowTouch,
    isNarrowDesktop,
    isNarrowWidescreen,
    isNarrowFullhd,
    isThreeQuartersMobile,
    isTwoThirdsMobile,
    isHalfMobile,
    isOneThirdMobile,
    isOneQuarterMobile,
    isFullMobile,
    isFourFifthsMobile,
    isThreeFifthsMobile,
    isTwoFifthsMobile,
    isOneFifthMobile,
    isThreeQuartersTablet,
    isTwoThirdsTablet,
    isHalfTablet,
    isOneThirdTablet,
    isOneQuarterTablet,
    isFullTablet,
    isFourFifthsTablet,
    isThreeFifthsTablet,
    isTwoFifthsTablet,
    isOneFifthTablet,
    isThreeQuartersTouch,
    isTwoThirdsTouch,
    isHalfTouch,
    isOneThirdTouch,
    isOneQuarterTouch,
    isFullTouch,
    isFourFifthsTouch,
    isThreeFifthsTouch,
    isTwoFifthsTouch,
    isOneFifthTouch,
    isThreeQuartersDesktop,
    isTwoThirdsDesktop,
    isHalfDesktop,
    isOneThirdDesktop,
    isOneQuarterDesktop,
    isFullDesktop,
    isFourFifthsDesktop,
    isThreeFifthsDesktop,
    isTwoFifthsDesktop,
    isOneFifthDesktop,
    isThreeQuartersWidescreen,
    isTwoThirdsWidescreen,
    isHalfWidescreen,
    isOneThirdWidescreen,
    isOneQuarterWidescreen,
    isFullWidescreen,
    isFourFifthsWidescreen,
    isThreeFifthsWidescreen,
    isTwoFifthsWidescreen,
    isOneFifthWidescreen,
    isThreeQuartersFullhd,
    isTwoThirdsFullhd,
    isHalfFullhd,
    isOneThirdFullhd,
    isOneQuarterFullhd,
    isFullFullhd,
    isFourFifthsFullhd,
    isThreeFifthsFullhd,
    isTwoFifthsFullhd,
    isOneFifthFullhd,
    ...rest
  } = _ref;
  let computedSize = size;
  if (width) {
    switch (width) {
      case '1/3':
        computedSize = 4;
        break;
      case '2/3':
        computedSize = 8;
        break;
      case '1/4':
        computedSize = 3;
        break;
      case '1/2':
        computedSize = 6;
        break;
      case '3/4':
        computedSize = 9;
        break;
      case '1':
        computedSize = 12;
        break;
      default:
        break;
    }
  }
  const classNames = (0, _classnames.default)({
    'is-three-quarters': isThreeQuarters,
    'is-two-thirds': isTwoThirds,
    'is-half': isHalf,
    'is-one-third': isOneThird,
    'is-one-quarter': isOneQuarter,
    'is-full': isFull,
    'is-four-fifths': isFourFifths,
    'is-three-fifths': isThreeFifths,
    'is-two-fifths': isTwoFifths,
    'is-one-fifth': isOneFifth,
    [`is-${computedSize}`]: computedSize,
    [`is-offset-${offsetSize}`]: offsetSize,
    'is-offset-three-quarters': isOffsetThreeQuarters,
    'is-offset-two-thirds': isOffsetTwoThirds,
    'is-offset-is-half': isOffsetHalf,
    'is-offset-one-third': isOffsetOneThird,
    'is-offset-one-quarter': isOffsetOneQuarter,
    'is-offset-four-fifths': isOffsetFourFifths,
    'is-offset-three-fifths': isOffsetThreeFifths,
    'is-offset-two-fifths': isOffsetTwoFifths,
    'is-offset-one-fifth': isOffsetOneFifth,
    'is-narrow': isNarrow,
    'is-narrow-mobile': isNarrowMobile,
    'is-narrow-tablet': isNarrowTablet,
    'is-narrow-touch': isNarrowTouch,
    'is-narrow-desktop': isNarrowDesktop,
    'is-narrow-widescreen': isNarrowWidescreen,
    'is-narrow-fullhd': isNarrowFullhd,
    'is-three-quarters-mobile': isThreeQuartersMobile,
    'is-two-thirds-mobile': isTwoThirdsMobile,
    'is-half-mobile': isHalfMobile,
    'is-one-third-mobile': isOneThirdMobile,
    'is-one-quarter-mobile': isOneQuarterMobile,
    'is-full-mobile': isFullMobile,
    'is-four-fifths-mobile': isFourFifthsMobile,
    'is-three-fifths-mobile': isThreeFifthsMobile,
    'is-two-fifths-mobile': isTwoFifthsMobile,
    'is-one-fifth-mobile': isOneFifthMobile,
    'is-three-quarters-tablet': isThreeQuartersTablet,
    'is-two-thirds-tablet': isTwoThirdsTablet,
    'is-half-tablet': isHalfTablet,
    'is-one-third-tablet': isOneThirdTablet,
    'is-one-quarter-tablet': isOneQuarterTablet,
    'is-full-tablet': isFullTablet,
    'is-four-fifths-tablet': isFourFifthsTablet,
    'is-three-fifths-tablet': isThreeFifthsTablet,
    'is-two-fifths-tablet': isTwoFifthsTablet,
    'is-one-fifth-tablet': isOneFifthTablet,
    'is-three-quarters-touch': isThreeQuartersTouch,
    'is-two-thirds-touch': isTwoThirdsTouch,
    'is-half-touch': isHalfTouch,
    'is-one-third-touch': isOneThirdTouch,
    'is-one-quarter-touch': isOneQuarterTouch,
    'is-full-touch': isFullTouch,
    'is-four-fifths-touch': isFourFifthsTouch,
    'is-three-fifths-touch': isThreeFifthsTouch,
    'is-two-fifths-touch': isTwoFifthsTouch,
    'is-one-fifth-touch': isOneFifthTouch,
    'is-three-quarters-desktop': isThreeQuartersDesktop,
    'is-two-thirds-desktop': isTwoThirdsDesktop,
    'is-half-desktop': isHalfDesktop,
    'is-one-third-desktop': isOneThirdDesktop,
    'is-one-quarter-desktop': isOneQuarterDesktop,
    'is-full-desktop': isFullDesktop,
    'is-four-fifths-desktop': isFourFifthsDesktop,
    'is-three-fifths-desktop': isThreeFifthsDesktop,
    'is-two-fifths-desktop': isTwoFifthsDesktop,
    'is-one-fifth-desktop': isOneFifthDesktop,
    'is-three-quarters-widescreen': isThreeQuartersWidescreen,
    'is-two-thirds-widescreen': isTwoThirdsWidescreen,
    'is-half-widescreen': isHalfWidescreen,
    'is-one-third-widescreen': isOneThirdWidescreen,
    'is-one-quarter-widescreen': isOneQuarterWidescreen,
    'is-full-widescreen': isFullWidescreen,
    'is-four-fifths-widescreen': isFourFifthsWidescreen,
    'is-three-fifths-widescreen': isThreeFifthsWidescreen,
    'is-two-fifths-widescreen': isTwoFifthsWidescreen,
    'is-one-fifth-widescreen': isOneFifthWidescreen,
    'is-three-quarters-fullhd': isThreeQuartersFullhd,
    'is-two-thirds-fullhd': isTwoThirdsFullhd,
    'is-half-fullhd': isHalfFullhd,
    'is-one-third-fullhd': isOneThirdFullhd,
    'is-one-quarter-fullhd': isOneQuarterFullhd,
    'is-full-fullhd': isFullFullhd,
    'is-four-fifths-fullhd': isFourFifthsFullhd,
    'is-three-fifths-fullhd': isThreeFifthsFullhd,
    'is-two-fifths-fullhd': isTwoFifthsFullhd,
    'is-one-fifth-fullhd': isOneFifthFullhd
  });
  const RenderAs = renderAs;
  const coreClassNames = (0, _CoreProps.useClassNames)(rest);
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('column', className, classNames, coreClassNames) || undefined
  }, children);
};
Column.propTypes = {
  className: _propTypes.default.string,
  width: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
  isThreeQuarters: _propTypes.default.bool,
  isTwoThirds: _propTypes.default.bool,
  isHalf: _propTypes.default.bool,
  isOneThird: _propTypes.default.bool,
  isOneQuarter: _propTypes.default.bool,
  isFull: _propTypes.default.bool,
  isFourFifths: _propTypes.default.bool,
  isThreeFifths: _propTypes.default.bool,
  isTwoFifths: _propTypes.default.bool,
  isOneFifth: _propTypes.default.bool,
  size: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  offsetSize: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  isOffsetThreeQuarters: _propTypes.default.bool,
  isOffsetTwoThirds: _propTypes.default.bool,
  isOffsetHalf: _propTypes.default.bool,
  isOffsetOneThird: _propTypes.default.bool,
  isOffsetOneQuarter: _propTypes.default.bool,
  isOffsetFourFifths: _propTypes.default.bool,
  isOffsetThreeFifths: _propTypes.default.bool,
  isOffsetTwoFifths: _propTypes.default.bool,
  isOffsetOneFifth: _propTypes.default.bool,
  isNarrow: _propTypes.default.bool,
  isNarrowMobile: _propTypes.default.bool,
  isNarrowTablet: _propTypes.default.bool,
  isNarrowTouch: _propTypes.default.bool,
  isNarrowDesktop: _propTypes.default.bool,
  isNarrowWidescreen: _propTypes.default.bool,
  isNarrowFullhd: _propTypes.default.bool,
  isThreeQuartersMobile: _propTypes.default.bool,
  isTwoThirdsMobile: _propTypes.default.bool,
  isHalfMobile: _propTypes.default.bool,
  isOneThirdMobile: _propTypes.default.bool,
  isOneQuarterMobile: _propTypes.default.bool,
  isFullMobile: _propTypes.default.bool,
  isFourFifthsMobile: _propTypes.default.bool,
  isThreeFifthsMobile: _propTypes.default.bool,
  isTwoFifthsMobile: _propTypes.default.bool,
  isOneFifthMobile: _propTypes.default.bool,
  isThreeQuartersTablet: _propTypes.default.bool,
  isTwoThirdsTablet: _propTypes.default.bool,
  isHalfTablet: _propTypes.default.bool,
  isOneThirdTablet: _propTypes.default.bool,
  isOneQuarterTablet: _propTypes.default.bool,
  isFullTablet: _propTypes.default.bool,
  isFourFifthsTablet: _propTypes.default.bool,
  isThreeFifthsTablet: _propTypes.default.bool,
  isTwoFifthsTablet: _propTypes.default.bool,
  isOneFifthTablet: _propTypes.default.bool,
  isThreeQuartersTouch: _propTypes.default.bool,
  isTwoThirdsTouch: _propTypes.default.bool,
  isHalfTouch: _propTypes.default.bool,
  isOneThirdTouch: _propTypes.default.bool,
  isOneQuarterTouch: _propTypes.default.bool,
  isFullTouch: _propTypes.default.bool,
  isFourFifthsTouch: _propTypes.default.bool,
  isThreeFifthsTouch: _propTypes.default.bool,
  isTwoFifthsTouch: _propTypes.default.bool,
  isOneFifthTouch: _propTypes.default.bool,
  isThreeQuartersDesktop: _propTypes.default.bool,
  isTwoThirdsDesktop: _propTypes.default.bool,
  isHalfDesktop: _propTypes.default.bool,
  isOneThirdDesktop: _propTypes.default.bool,
  isOneQuarterDesktop: _propTypes.default.bool,
  isFullDesktop: _propTypes.default.bool,
  isFourFifthsDesktop: _propTypes.default.bool,
  isThreeFifthsDesktop: _propTypes.default.bool,
  isTwoFifthsDesktop: _propTypes.default.bool,
  isOneFifthDesktop: _propTypes.default.bool,
  isThreeQuartersWidescreen: _propTypes.default.bool,
  isTwoThirdsWidescreen: _propTypes.default.bool,
  isHalfWidescreen: _propTypes.default.bool,
  isOneThirdWidescreen: _propTypes.default.bool,
  isOneQuarterWidescreen: _propTypes.default.bool,
  isFullWidescreen: _propTypes.default.bool,
  isFourFifthsWidescreen: _propTypes.default.bool,
  isThreeFifthsWidescreen: _propTypes.default.bool,
  isTwoFifthsWidescreen: _propTypes.default.bool,
  isOneFifthWidescreen: _propTypes.default.bool,
  isThreeQuartersFullhd: _propTypes.default.bool,
  isTwoThirdsFullhd: _propTypes.default.bool,
  isHalfFullhd: _propTypes.default.bool,
  isOneThirdFullhd: _propTypes.default.bool,
  isOneQuarterFullhd: _propTypes.default.bool,
  isFullFullhd: _propTypes.default.bool,
  isFourFifthsFullhd: _propTypes.default.bool,
  isThreeFifthsFullhd: _propTypes.default.bool,
  isTwoFifthsFullhd: _propTypes.default.bool,
  isOneFifthFullhd: _propTypes.default.bool
};
Column.defaultProps = {
  renderAs: 'div'
};
var _default = exports.default = Column;
//# sourceMappingURL=Column.js.map